import { useEffect } from "react";
import { useDispatch } from "react-redux";
import useCustomState from "../hooks/State";
import { UpdateNavigations } from "../store/actions";
import ShowBillFilter from "../components/ShowBills/ShowBillFilter";
import Call from "../service/API";
import NoData from "../components/BillsFilter/NotFound";
import SimpleTable from "../components/CustomTable/SimpleTable";
import moment from "jalali-moment";
import "../components/BillsFilter/main.css";
const ShowBill = () => {
  const isLoading = useCustomState(true);
  const projects = useCustomState([]);
  const projectSelected = useCustomState("");
  const counters = useCustomState([]);
  const counterSelected = useCustomState({});
  const counterBills = useCustomState([]);
  const billTableData = useCustomState([]);
  const counterTableData = useCustomState([]);
  //............................................
  const dispatch = useDispatch();
  const utils = {
    page: 1,
    count: 10000,
    projectNameFilter: null,
    projectCreateDateFilter: null,
  };
  const prepareCounter = (counterData) => {
    let data = [];
    if (counterData.water_meter_name) {
      data.push({
        couName: counterData.water_meter_name,
        couSerial: counterData.water_meter_serial,
        couCategory: counterData.water_meter_tag_info.water_meter_tag_name,
        couType: counterData.water_meter_type_info.water_meter_type_name,
        owner: `${counterData.water_meter_user_info.user_name} ${counterData.water_meter_user_info.user_lastname}`,
      });
    }
    counterTableData.handleChange(data);
  };
  const counterTableHeader = [
    { title: "نام کنتور", key: "couName" },
    { title: "شماره سریال", key: "couSerial" },
    { title: "دسته کنتور", key: "couCategory" },
    { title: "نوع کنتور", key: "couType" },
    { title: "مالک کنتور", key: "owner" },
  ];
  const prepareBillsTable = (billsData) => {
    let data = [];
    billsData.forEach((bill) => {
      data.push({
        billSerial: bill.bill_serial,
        billFrom: moment(bill.bill_start_date)
          .locale("fa")
          .format("YYYY/MM/DD"),
        billTill: moment(bill.bill_end_date).locale("fa").format("YYYY/MM/DD"),
        consumptions: bill.consumptions.toLocaleString(undefined, {
          minimumFractionDigits: 1,
          maximumFractionDigits: 1,
        }),
        price: Math.round(bill.bill_price).toLocaleString(),
        deadLine: moment(bill.payment_dead_line)
          .locale("fa")
          .format("YYYY/MM/DD"),
        billId: bill.bill_id,
      });
    });
    billTableData.handleChange(data);
  };
  const billsTableHeader = [
    { title: "شناسه قبض", key: "billSerial" },
    { title: "از تاریخ", key: "billFrom" },
    { title: "تا تاریخ", key: "billTill" },
    { title: "میزان مصرف", key: "consumptions" },
    { title: "مبلغ قبض (ریال)", key: "price" },
    { title: "مهلت پرداخت", key: "deadLine" },
    { title: "مشاهده جزئیات", key: "billId" },
  ];
  const selectedProjectChange = (event) => {
    projectSelected.handleChange(event.target.value);
    counterSelected.handleChange({});
    if (!!event.target.value && event.target.value.length > 0) {
      fetchCounters(event.target.value, counters);
    }
  };
  const selectedCounterChange = (event) => {
    let selected = counters.value.filter(
      (item) => item.water_meter_name === event.target.innerText
    );
    counterSelected.handleChange(selected.length > 0 ? selected[0] : {});
    prepareCounter(selected.length > 0 ? selected[0] : {});
  };
  const getBills = () => {
    fetchBills(
      projectSelected.value,
      counterSelected.value.water_meter_serial,
      counterBills,
      prepareBillsTable
    );
  };
  //...........................................
  useEffect(() => {
    const navigations = [{ name: "مشاهده قبض", path: "/admin/show-bills" }];
    dispatch(UpdateNavigations(navigations));
    fetchprojectsList(utils, isLoading, projects);
  }, []);
  //...........................................
  if (!isLoading.value) {
    return (
      <>
        <div
          style={{
            paddingRight: "8px",
            paddingLeft: "8px",
          }}
        >
          <ShowBillFilter
            projects={projects}
            projectSelected={projectSelected}
            projectChanged={selectedProjectChange}
            counters={counters}
            selectedCounter={counterSelected}
            counterChanged={selectedCounterChange}
            getBills={getBills}
          />
          <h4>مشخصات کنتور</h4>
          <SimpleTable
            hasIndex={false}
            hasLink={false}
            header={counterTableHeader}
            data={counterTableData.value}
          />
          {counterBills.value.length > 0 ? (
            <SimpleTable
              hasIndex={true}
              hasLink={true}
              navigation={"/admin/show-bills"}
              header={billsTableHeader}
              data={billTableData.value}
              newPageLink={true}
            />
          ) : (
            <NoData message={"قبضی برای نمایش موجود نمیباشد!!!"} />
          )}
        </div>
      </>
    );
  } else {
    return null;
  }
};

export default ShowBill;
const fetchprojectsList = (utils, isLoading, projects) => {
  const page = utils.page;
  const count = utils.count;
  const projectNameFilter = utils.projectNameFilter;
  const projectCreateDateFilter = utils.projectCreateDateFilter;
  const data = {
    page: page,
    count: count,
    water_meter_project_name: projectNameFilter,
    water_meter_project_create_date: projectCreateDateFilter,
  };
  Call("POST", "WaterMeterProjectsURL/admin/getAll", data)
    .then((response) => {
      if (response.data.code === 200) {
        const ps = response.data.data;
        projects.handleChange(ps);
        isLoading.handleChange(false);
      }
    })
    .catch((error) => {
      if (error.response) {
        const data = error.response.data;
        if (data.code === 403) {
        }
      }
      isLoading.handleChange(false);
    });
};
const fetchCounters = (projectId, counters) => {
  const page = 1;
  const count = 1000;
  const userId = null;
  const data = {
    page: page,
    count: count,
    user_id: userId,
    project_id: projectId,
  };
  Call("POST", "watermeters/admin/getAll", data)
    .then((response) => {
      if (response.data.code === 200) {
        counters.handleChange(response.data.data);
      }
    })
    .catch((error) => {
      if (error.response) {
        counters.handleChange([]);
      }
    });
};
const fetchBills = (projectId, counterSerial, bills, prepareBillsTable) => {
  const page = 1;
  const count = 1000;
  const data = {
    page: page,
    count: count,
    water_meter_serial: counterSerial,
    bill_serial: null,
    bill_start_date: null,
    user_id: null,
    user_phone_number: null,
    project_id: projectId,
    bill_end_date: null,
    payment_dead_line: null,
    bill_create_date: null,
  };
  Call("POST", "bills/admin/getAll", data)
    .then((response) => {
      if (response.data.code === 200) {
        bills.handleChange(response.data.data);
        prepareBillsTable(response.data.data);
      }
    })
    .catch((error) => {
      if (error.response) {
        bills.handleChange([]);
      }
    });
};
